import Helmet from '../lib/Helmet';
import CartContents from '../components/CartContents';
import { track, FUNNEL } from '../lib/track';
import { useEffect } from 'react';

// Route: /cart
//
// The same cart as the slide-out drawer, as a page, for anyone who lands here
// directly. Everything happens in CartContents so the two never disagree.

export default function Cart() {
  useEffect(() => { track(FUNNEL.CART_VIEW, { source: 'page' }); }, []);

  return (
    <>
      <Helmet>
        <title>Your cart | Citi Cool</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <main className="mx-auto w-full max-w-xl px-4 pb-10 pt-24 lg:pt-28">
        <h1 className="mb-3 text-xl font-bold text-gray-900">Your cart</h1>
        <CartContents variant="page" />
      </main>
    </>
  );
}
